// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BundleSize__dl {\n  margin-bottom: 0;\n}\n.BundleSize__dt {\n  float: left;\n  clear: left;\n  width: 5rem;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.BundleSize__dd {\n  margin-left: 5.5rem;\n}\n.BundleSize__SVGIcon {\n  vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
